/**
 * Licensed Materials - Property of IBM	
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.	
 */

define([
	'react',
	'baglass/app/plugins/GlassPlugin',
	'ca-content/bridge/nls/StringResources',
	'ca-content/glass/glass',
], (React, GlassPluginController, StringResources, glass) => {

	const { SearchHelper, close16 } = glass;
	const SEARCH_PERSPECTIVE = 'searchContent';

	function getCurrentValue(glassContext) {
		if (glassContext.getCurrentPerspective() === SEARCH_PERSPECTIVE) {
			// searchBar renders before the content view, so get the searchTerm from the perspectiveModel
			const spec = glassContext.currentAppView.perspectiveModel.spec;
			const content = spec && spec.content || {};
			return content.searchTerm || '';
		} else if ($('.ba-autoComplete-searchBar input').length > 0) {
			// create new appView for the first time, try to get value from previous view
			return $('.ba-autoComplete-searchBar input').val();
		}
		return '';
	}

	return class SearchBarController extends GlassPluginController {

		initialize(options) {
			this.plugin = options.target.plugin;
			this.glassContext = options.glassContext;
			this.searchHelper = new SearchHelper({ glassContext: options.glassContext });
			this.eventRouter = this.glassContext.getCoreSvc('.Events');
			this.eventRouter.on('globalSearch:valueChange', this.updateSearchBarValue, this);

			const initialValue = getCurrentValue(options.glassContext);
			if (initialValue) {
				this.plugin.setValue(initialValue);
			}
		}

		// <Search Action Controller API>
		doSearch(context) {
			const value = context.target.plugin.getValue();
			const searchString = typeof value === 'string' ? value : value.value;
			const searchTerm = searchString.trim();
			return this.glassContext.openAppView(SEARCH_PERSPECTIVE, {
				content: {
					searchTerm
				}
			});
		}

		onChange(context) {
			const searchTerm = context.evt;
			context.target.plugin.setValue(searchTerm)

			// trigger value change events to sync the searchBar value across other appViews
			this.eventRouter.trigger('globalSearch:valueChange', { searchTerm });
			if (searchTerm.length > 0) {
				return this._getSuggestions(context, searchTerm);
			} else {
				return this._getSavedSearch(context);
			}
		}

		onFocus(context) {
			const value = context.target.plugin.getValue();
			if (value.length > 0) {
				return this._getSuggestions(context, value);
			} else {
				return this._getSavedSearch(context);
			}
		}
		// </Search Action Controller API>

		_getSuggestions(context, searchTerm) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				this._searchTerm = searchTerm;
				return this.searchHelper.getSuggestions(searchTerm).then(suggestions => {
					if (this._searchTerm !== searchTerm) return; // short-circuit stale results
					const values = suggestions.map(suggestion => ({
						group: StringResources.get('searchSuggestions'),
						label: suggestion,
						value: suggestion
					}));
					context.target.plugin.setValues(values);
				});
			}, 50);
		}

		_getSavedSearch(context) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				return this.searchHelper.getSavedSearch().then(savedSearches => {
					const values = savedSearches.map(savedSearch => {
						return {
							group: StringResources.get('savedSearch'),
							label: savedSearch.name,
							value: savedSearch.name,
							icon: close16.id,
							onIconClick: (e) => { this.onIconClick(e, savedSearch.url, savedSearch.name, context); }
						};
					});
					context.target.plugin.setValues(values);
				});
			}, 50);
		}

		updateSearchBarValue(options) {
			this.plugin && this.plugin.setValue(options.searchTerm);
		}

		onIconClick(e, url, searchTerm, context) {
			e.stopPropagation();
			e.preventDefault();
			context.target.plugin.setValue('');
			return this.searchHelper.deleteSavedSearch(url, searchTerm);
		}
	};

});